import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ icon, title, subtitle, moreTo, moreLabel = '查看更多' }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl md:text-2xl font-bold text-foreground-950">
          <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-500/15 text-accent-400">
            <i className={`${icon} text-lg`}></i>
          </span>
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 flex items-center gap-1 text-sm font-medium text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}